module.exports = __webpack_public_path__ + "static/media/san.92c263a1.svg";